<section id="section04">

    <div class="container">

        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-md-8">
                <div class="section-header">
                    <h2>{{ data.TITULO }}</h2>
                    <h4>{{ data.DESCRICAO }}</h4>
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-center align-items-center">
            <div *ngFor="let segmento of data.SEGMENTOS" class="col-md-6 col-lg-4 mb-4">
                <div class="card rounded-0 border-0" [routerLink]="[ segmento.URL | localize ]">
                    <div class="card-body p-0">
                        <img src="{{ segmento.IMAGEM.URL }}" alt="{{ segmento.IMAGEM.DESCRICAO }}" class="img-fluid">
                    </div>
                    <div class="card-footer rounded-0 text-center text-white bg-primary p-4">
                        {{ segmento.TEXTO }}
                    </div>
                </div>
            </div>
        </div>

    </div>

</section>